module.exports = __webpack_public_path__ + "img/mtt_2.2.6dd4e011.png";